import React from 'react';
import { CircleNotch, Copy, Plus, Upload } from '@phosphor-icons/react';
import { Button } from '../../components/ui/button';

export const EmployeesPageHeader = ({
  scanningDuplicates, onScanDuplicates, onImport, onAddEmployee,
}) => (
  <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
    <div>
      <h1 className="text-3xl font-bold text-slate-900" style={{ fontFamily: 'Manrope' }}>
        Employees
      </h1>
      <p className="text-slate-500 mt-1">Manage caregivers and staff for EVV and billing</p>
    </div>
    <div className="flex gap-2 flex-wrap">
      <Button
        variant="outline"
        size="sm"
        onClick={onScanDuplicates}
        disabled={scanningDuplicates}
        data-testid="scan-employee-duplicates-btn"
      >
        {scanningDuplicates
          ? <CircleNotch size={16} className="mr-1 animate-spin" />
          : <Copy size={16} className="mr-1" />}
        Find Duplicates
      </Button>
      <Button variant="outline" onClick={onImport} data-testid="import-employees-btn">
        <Upload size={18} className="mr-2" /> Import
      </Button>
      <Button
        onClick={onAddEmployee}
        className="bg-indigo-900 hover:bg-indigo-800"
        data-testid="add-employee-btn"
      >
        <Plus size={18} className="mr-2" /> Add Employee
      </Button>
    </div>
  </div>
);

export default EmployeesPageHeader;
